/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 PRO React base styles
import colors from "assets/theme-dark/base/colors";

// Material Dashboard 2 PRO React helper functions
import rgba from "assets/theme-dark/functions/rgba";
import { ESCURO } from "assets/coresTema";

const { info, white, gradients } = colors;

// Janela do calendário no cinza dos blocos, como o resto do modo escuro (o flatpickr.css deixava branca, com o mês, os
// dias da semana e as setas escuros, e a faixa entre as datas do período em cinza claro)
const janelaEscura = {
  ".flatpickr-calendar": {
    background: `${ESCURO.cartao} !important`,
    border: `1px solid ${ESCURO.borda}`,
    boxShadow: "0 4px 16px rgba(0, 0, 0, 0.35) !important",
  },
  ".flatpickr-calendar.arrowTop:before": { borderBottomColor: `${ESCURO.borda} !important` },
  ".flatpickr-calendar.arrowTop:after": { borderBottomColor: `${ESCURO.cartao} !important` },
  ".flatpickr-calendar.arrowBottom:before": { borderTopColor: `${ESCURO.borda} !important` },
  ".flatpickr-calendar.arrowBottom:after": { borderTopColor: `${ESCURO.cartao} !important` },
  ".flatpickr-months .flatpickr-month, .flatpickr-current-month .flatpickr-monthDropdown-months, .flatpickr-current-month input.cur-year": {
    color: `${ESCURO.texto} !important`,
    fill: `${ESCURO.texto} !important`,
    background: "transparent !important",
  },
  ".flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month": {
    background: `${ESCURO.campo} !important`,
    color: `${ESCURO.texto} !important`,
  },
  ".flatpickr-months .flatpickr-prev-month, .flatpickr-months .flatpickr-next-month": {
    color: `${ESCURO.texto} !important`,
    fill: `${ESCURO.texto} !important`,
  },
  ".flatpickr-months .flatpickr-prev-month svg, .flatpickr-months .flatpickr-next-month svg": {
    fill: `${ESCURO.texto} !important`,
  },
  ".numInputWrapper span.arrowUp:after": { borderBottomColor: `${ESCURO.texto} !important` },
  ".numInputWrapper span.arrowDown:after": { borderTopColor: `${ESCURO.texto} !important` },
  "span.flatpickr-weekday": {
    color: `${ESCURO.textoSecundario} !important`,
    background: "transparent !important",
  },
  ".flatpickr-day": { color: `${ESCURO.texto} !important` },
  ".flatpickr-day.prevMonthDay, .flatpickr-day.nextMonthDay, .flatpickr-day.flatpickr-disabled, .flatpickr-day.flatpickr-disabled:hover": {
    color: `${ESCURO.textoFraco} !important`,
    opacity: 0.55,
  },
  ".flatpickr-day.inRange, .flatpickr-day.prevMonthDay.inRange, .flatpickr-day.nextMonthDay.inRange": {
    background: `${ESCURO.hover} !important`,
    borderColor: `${ESCURO.hover} !important`,
    boxShadow: `-5px 0 0 ${ESCURO.hover}, 5px 0 0 ${ESCURO.hover} !important`,
    color: `${ESCURO.texto} !important`,
  },
  ".flatpickr-time input, .flatpickr-time .flatpickr-am-pm, .flatpickr-time .flatpickr-time-separator": {
    color: `${ESCURO.texto} !important`,
  },
  ".flatpickr-calendar.hasTime .flatpickr-time": { borderTopColor: `${ESCURO.divisoria} !important` },
};

const flatpickr = {
  ...janelaEscura,

  ".flatpickr-day:hover, .flatpickr-day:focus, .flatpickr-day.nextMonthDay:hover, .flatpickr-day.nextMonthDay:focus":
    {
      background: rgba(info.main, 0.28),
      border: "none",
    },

  ".flatpickr-day.today": {
    background: info.main,
    color: white.main,
    border: "none",

    "&:hover, &:focus": {
      background: `${info.focus} !important`,
    },
  },

  ".flatpickr-day.selected, .flatpickr-day.selected:hover, .flatpickr-day.nextMonthDay.selected, .flatpickr-day.nextMonthDay.selected:hover, .flatpickr-day.nextMonthDay.selected:focus":
    {
      background: `${gradients.info.state} !important`,
      color: white.main,
      border: "none",
    },

  ".flatpickr-months .flatpickr-next-month:hover svg, .flatpickr-months .flatpickr-prev-month:hover svg":
    {
      color: `${info.main} !important`,
      fill: `${info.main} !important`,
    },
};

export default flatpickr;
